<div class="modal-body p-0">
  <div class="container-fluid">
    @if (screen === 'businessobjectives') {
      <div class="back d-flex" (click)="backToObjective()">
        Back to <span [innerHTML]="selectedObjective.title"></span>
      </div>
    }
    <div class="row">
      <div class="col px-3 py-4">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12 d-flex flex-wrap">
              @for (dimension of assessmentDimensions; track dimension) {
                <div class="main-box">
                  <div class="img-box">
                    <img [src]="headerIconBasePath + dimension.key + '.png'" alt="" height="27px" width="27px"
                      class="imagee" />
                    <p class="title">{{ dimension.label }}</p>
                  </div>
                  <div class="color-box"
                  [style.background-color]="getBgColor(this.otdata[dimension.key])['background-color']"></div>
                  <p class="down-content">
                    {{ this.otdata[dimension.key] || "NOT ASSESSED" | uppercase }}
                  </p>
                </div>
              }

              <div class="main-box">
                <div class="img-box">
                  <img [src]="getDecisionImage(otdata.decision)" alt="" height="27px" width="27px" class="imagee" />
                  <p class="title">Decision</p>
                </div>
                <div class="color-box12"></div>
                <p class="down-content">{{ otdata.decision || "Undecided" | uppercase }}</p>
              </div>
            </div>

            <div class="col-12 mt-3">
              <hr />
            </div>

            <div class="col-lg-3">
              <div class="d-flex align-items-center mb-2">
                <img [src]="otdataPic" alt="" class="me-3" width="74px" appImageFallback
                  [fallbackSrc]="'/assets/images/public/default-asset.png'" />
                <div>
                  <p class="fs-13 text-info2 mb-0 mt-3 mt-lg-0">UNIQUE ID*</p>
                  <p class="fs-16 m-0 ps-12">{{ otdata.otID }}</p>
                </div>
              </div>
            </div>

            <div class="col-xl-3">
              <p class="text-info2 mb-0 fs-13">ASSET NAME</p>
              <p class="mb-0 fs-16">{{ otdata.assetName }}</p>
            </div>

            <div class="col-6 mb-3">
              <p class="text-info2 mb-1 fs-13">ASSET DESCRIPTION</p>
              <p class="mb-0 fs-16" [innerHTML]="otdata.assetDescription" style="max-height: 120px; overflow-y: auto">
              </p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">ASSET TYPE</p>
              <p class="mb-0 fs-16">{{ otdata.assetType || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">ASSET IDENTIFIER</p>
              <p class="mb-0">{{ otdata.identifier || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">MANUFACTURER</p>
              <p class="mb-0">{{ otdata.manufacturer || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">MODEL</p>
              <p class="mb-0">{{ otdata.model || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">INSTALLATION DATE</p>
              <p class="mb-0">{{ otdata.installationDate | date : company?.display_date_format }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">IN SUPPORT?</p>
              <p class="mb-0">{{ formatInSupport(otdata.inSupport) }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">END OF SUPPORT DATE</p>
              <p class="mb-0">{{ otdata.endOfSupportDate | date : company?.display_date_format }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">CONNECTED?</p>
              <p class="mb-0">{{ formatConnected(otdata.connected) }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">FIRMWARE OR SOFTWARE VERSION</p>
              <p class="mb-0">{{ otdata.softwareVersion || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">OPERATING SYSTEM</p>
              <p class="mb-0">{{ otdata.os || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">PATCH LEVEL OR LAST PATCH DATE</p>
              <p class="mb-0">{{ otdata.lastPatchDate }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">OPERATIONAL CRITICALITY</p>
              <p class="mb-0">{{ formatCriticality(otdata.criticality) }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">UTILISATION</p>
              <p class="mb-0">{{ formatUtilisation(otdata.assetUtilisation) }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">REDUNDANCY</p>
              <p class="mb-0">{{ formatRedundancy(otdata.redundancy) }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">ASSET LOCATION</p>
              <p class="mb-0">{{ otdata.location || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">BUSINESS OWNER</p>
              <p class="mb-0">{{ otdata.businessOwner || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">SUPPORT OWNER</p>
              <p class="mb-0">{{ otdata.supportOwner || '-' }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">
                ANNUAL COST(<span [innerHTML]="company ? company.curr : ''"></span>)
              </p>
              <p class="mb-0">{{ formatNumber(otdata.annualCost) }}</p>
            </div>

            <div class="col-6 col-lg-3 mb-3 mt-3">
              <p class="text-info2 mb-1 fs-13">
                TOTAL COST(<span [innerHTML]="company ? company.curr : ''"></span>)
              </p>
              <p class="mb-0">{{ formatNumber(otdata.totalCost) }}</p>
            </div>

            <div class="col-12">
              <hr class="my-2 mt-3 px-3" />
            </div>

            <!-- CUSTOM FIELDS -->
            @if (otdata?.categories && otdata.categories.length > 0) {
              <div class="col-12">
                <p class="fs-20 text-info2 fw-500 border-bottom mb-3">
                  CUSTOM FIELDS
                </p>
                <div class="row mb-34">
                  @for (cat of otdata.categories; track cat) {
                    <div class="col-xl-3 col-lg-3 col-md-6 mb-3">
                      <div class="text-dark">
                        <p class="text-info2 mb-1 fs-13">{{ cat.label }}</p>
                        <p class="mb-0 fs-16">{{ cat.value || '-' }}</p>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }

            <div class="col-12">
              <hr class="my-2 mt-3 px-3" />
            </div>

            <div class="col-12">
              <div class="container-fluid p-3">
                <app-mapping-card-popup [context]="'otdata'" [currentSelectedItem]="otdata"
                  [strategyId]="appService.currentActivatedFeature.strategyId" [showButtons]="false"
                  (mappingsChange)="onMappingsChange($event)">
                </app-mapping-card-popup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>